import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition } from "@mcurros2/microm";

const columns = () =>
(
    {
        dt_fecha_desde: new EntityColumn<Date>({ name: 'dt_fecha_desde', type: 'datetime', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Fecha Desde' }),
        dt_fecha_hasta: new EntityColumn<Date>({ name: 'dt_fecha_hasta', type: 'datetime', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Fecha Hasta' }),
        ...DefaultColumns()
    }
)

export class PersonalLicenciasFiltersDef extends EntityDefinition {

    columns = columns();

    constructor() {
        super('PersonalLicenciasFilters');
    }
}